
import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import { Link, NavLink } from 'react-router-dom'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import DynamicGradientTables from '../../../../../_components/common/DynamicGradientTables'
import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';
import { collaborationAction } from '../../../../../_actions/Analyze/collaboration.action'
import dataFormater from '../../dataFormater';
import { global_data } from '../../globalData';


import AchievementLogo from '../../../../../images/AOlogo.png';
import LeadershipLogo from '../../../../../images/LEOlogo.png';
import LearningLogo from '../../../../../images/LOlogo.png';
import NurturingLogo from '../../../../../images/NOlogo.png';
import RelationshipLogo from '../../../../../images/ROlogo.png';
import SwotIcon from '../../../../../images/swotIcon.png';
import guideTitle from '../../../../../images/guideTitle.png';
import learnTitle from '../../../../../images/learnTitle.png'
import collaborateTitle from '../../../../../images/collaborateTitle.png';


const PercentageChart = (props) => {
    const data = []

    props.data.map(val => {
        if(val.header_text.toLowerCase() == props.orientationName.toLowerCase()) {
            val.child_content.map(value => {
                let dataObj = {
                    title: value.attribute_name,
                    sub_title: '',
                    // sub_title: 'Dreaming big and generating ideas',
                    title_value: value.average_score.filter(score => score.team === "current_team_respondents_avg_score").map(score => score.score).reduce((acc, current) => acc + current),
                    sub_title_value: value.average_score.filter(score => score.team === "collabaration_team_respondents_avg_score").map(score => score.score).reduce((acc, current) => acc + current),
                    backgroundColor: {
                        light: val.backgroundColor.light,
                        dark: val.backgroundColor.dark
                    }
                }
                
                data.push(dataObj)
            })
        }
    })


    return (
        <div className="d-flex flex-column">
            {
                data.map((val, key) => {
                    return (
                        <React.Fragment>
                        <div key={key} className="d-flex flex-row col-12 m-1" style={{fontSize: 12}}>
                            <div className="col-3 border px-2 py-1 align-items-center text-left d-flex">
                                <p className="font-weight-bold mb-0">
                                    {val.title}
                                </p>
                                <small className="mb-0">
                                    {val.sub_title}
                                </small>
                            </div>
                            <div className="col-7 border py-2 px-0" style={{ display: 'flex', flexDirection: 'column', }}>
                                <div style={{ display: 'flex', flex: 10, flexDirection: 'row', }}>
                                    <div style={{ flex: parseFloat(val.title_value), backgroundColor: val.backgroundColor.light }}>
                                    </div>
                                    <div className="text-left px-1" style={{ flex: (10 - parseFloat(val.title_value)) }}>
                                        {val.title_value.toFixed(2)}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flex: 10, flexDirection: 'row', }}>
                                    <div style={{ flex: parseFloat(val.sub_title_value), backgroundColor: val.backgroundColor.dark }}>
                                    </div>
                                    <div className="text-left px-1" style={{ flex: 10 - parseFloat(val.sub_title_value) }}>
                                        {val.sub_title_value.toFixed(2)}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-row col-2 border py-1 align-items-center justify-content-around">
                                <div className="">
                                    <i className={`fa ${(val.title_value - val.sub_title_value) > 0.5 ? "fa-arrow-up" : (val.title_value - val.sub_title_value) < -0.5 ? "fa-arrow-down" : "fa-arrows-alt-h"} diff`} style={{ color: (val.title_value - val.sub_title_value) < -0.5 ? 'rgb(237, 55, 55)' : (val.title_value - val.sub_title_value) > 0.5 ? 'rgb(52, 141, 89)' : '#000' }}></i>
                                </div>
                                <div className="mb-0 diff" style={{ color: (val.title_value - val.sub_title_value) <= 0 ? val.backgroundColor.light : val.backgroundColor.dark }}>
                                    {(val.title_value - val.sub_title_value).toFixed(2)}
                                </div>
                            </div>
                        </div>
                        {
                            key == data.length - 1 ?
                            <div className="d-flex flex-row-reverse justify-content-start align-items-center my-3 py-2">
                                <div className="d-flex flex-row border">
                                    <div className="d-flex flex-row px-3 align-items-center">
                                        <div className="px-1" style={{ backgroundColor: val.backgroundColor.light, height: 10, width: 10 }}></div>
                                        <p className="mb-0 px-1">{props.data[0].teamData.currentTeam}</p>
                                    </div>
                                    <div className="d-flex flex-row px-3 align-items-center">
                                        <div className="px-1" style={{ backgroundColor: val.backgroundColor.dark, height: 10, width: 10 }}></div>
                                        <p className="mb-0 px-1">{props.data[0].teamData.selected_team}</p>
                                    </div>
                                </div>
                            </div>:
                            null
                        }
                        </React.Fragment>
                    )
                })
            }
        </div>
    )
}
class Collaboration extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamName: '',
            teamId: localStorage.getItem('teamId'),
            getPaUserPermissionListResponse: '',
            view_detailed_comparison: null,
            navData: [],
            canCallApiIfNoData: false,
            main_button_data: [
                {
                    img: SwotIcon,
                    link: `/organisation/${this.props.match.params.id}/user/collaboration/`,
                    name: "Collaboration",
                    id: "Collaboration",
                    tooltip_id: 0
                }
            ],
            detailed_button_data: [
                {
                    img: guideTitle,
                    link: `/organisation/${this.props.match.params.id}/user/collaboration/detailed/1/${this.props.match.params.teamId}`,
                    name: "GUIDE",
                    id: "1",
                    tooltip_id: 1
                },
                {
                    img: learnTitle,
                    link: `/organisation/${this.props.match.params.id}/user/collaboration/detailed/2/${this.props.match.params.teamId}`,
                    id: "2",
                    name: "LEARN",
                    tooltip_id: 2
                },
                {
                    img: collaborateTitle,
                    link: `/organisation/${this.props.match.params.id}/user/collaboration/detailed/3/${this.props.match.params.teamId}`,
                    id: "3",
                    name: "COLLABORATE",
                    tooltip_id: 3
                },
            ],
            button_data: [
                {
                    img: SwotIcon,
                    link: '/organisation/1/user/swot/0',
                    name: "Collaboration",
                    id: null,
                    tooltip_id: 0
                },
                {
                    img: AchievementLogo,
                    link: '/organisation/1/user/swot/1',
                    id: "ACHIEVEMENT",
                    name: "Achievement Orientation",
                    tooltip_id: 1
                },
                {
                    img: RelationshipLogo,
                    link: '/organisation/1/user/swot/2',
                    id: "RELATIONSHIP",
                    name: "Relationship Orientation",
                    tooltip_id: 2
                },
                {
                    img: LeadershipLogo,
                    link: '/organisation/1/user/swot/3',
                    id: "LEADERSHIP",
                    name: "Leadership Orientation",
                    tooltip_id: 3
                },
                {
                    img: LearningLogo,
                    link: '/organisation/1/user/swot/4',
                    id: "LEARNING",
                    name: "Learning Orientation",
                    tooltip_id: 4
                },
                {
                    img: NurturingLogo,
                    link: '/organisation/1/user/swot/5',
                    id: "NURTURING",
                    name: "Nurturing Orientation",
                    tooltip_id: 5
                },
            ],
            select_data: [],
            select_data_loader: true,
            class_name: {
                main_container: 'd-flex flex-row flex-wrap px-0 col-12 align-items-start col-12',
                container: {
                    container: "d-flex flex-column col-sm-4 col-md-4 col-lg-4 w-100 p-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 50,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row justify-content-center text-white',
                    header_container_non_routable_title: '',
                    header_container_non_routable_optional: '',
                },
                child_container: {
                    child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0",
                    style: {
                        margin: 1
                    }
                },
                sub_header_enable: {
                    child_content_container_header: 'font-weight-bold font-italic py-1 sub_header_style',
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-wrap col-sm-12 col-md-12 col-lg-12 py-1 px-3 my-1 text-dark justify-content-around align-items-center',
                    child_content_container_header: 'font-weight-bold py-1 text-break',
                    child_content_container_desc: 'font-weight-bold font-italic',
                    child_content_container_footer: '',
                }
            },
            detailed_class_name: {
                main_container: 'd-flex flex-row flex-wrap align-items-center col-12 text-left',
                container: {
                    container: "d-flex flex-column col-sm-12 col-md-12 col-lg-12 w-100 p-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 mx-1 my-1',
                    style: {
                        paddingLeft: 20,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row text-white font-italic align-items-center',
                    header_container_non_routable_title: 'px-2',
                    header_container_non_routable_optional: 'px-2',
                },
                child_container: {
                    child_container: "d-flex flex-row col-12 justify-content-center flex-wrap w-100 px-0",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-column col-4 text-dark low_padding_child_content',
                    child_content_container_header: 'font-weight-bold ',
                    child_recomended_points_container: 'font-weight-bold font-size-12',
                    child_recomended_points_header: 'font-weight-bold',
                    child_recomended_points_list_container: 'child_recomended_points_list_container_adjust pad-x-0_4rem',
                    child_recomended_points_list_items: 'font-italic',
                    show_button_container: 'd-flex justify-content-center align-items-center my-2',
                    show_button:'btn btn-dark font-italic font-weight-bold show_button_child_button',
                    child_content_container_desc: '',
                    child_content_container_footer: '',
                }
            },
            data: [],
            filterData: null,

            data_percentage_chart: [],

            selected_team: null,
            collabErrorMessage: ''
        }

        this.selected_team_ref = React.createRef();
    }

    componentDidUpdate(prev, prevState) {

        if(prev.assessorGroupsResponse !== this.props.assessorGroupsResponse) {
            if(this.props.assessorGroupsResponse !== '') {
                if(this.props.match.params.teamId == localStorage.getItem('teamId')) {
                    this.props.history.replace(`/organisation/${this.props.match.params.id}/user/collaboration/`)
                }else {
                    this.setState({
                        teamName: localStorage.getItem('teamName') ? localStorage.getItem('teamName') : '',
                        selected_team: null
                    }, () => {
                        var temp_arr = []
                        var reformatdata = []
                            var tableData = this.props.getPaAnanlyzeTeamListResponse.data
                            for (var key in tableData) {
                                if (tableData.hasOwnProperty(key)) {
                                    reformatdata = reformatdata.concat(tableData[key])
                                }
                            }
        
                        var sortedArray =  reformatdata.sort(function(a, b) { 
                            return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
                            });
        
                        sortedArray.map(obj => {
                            if(localStorage.getItem('teamId') != obj.id) {
                                temp_arr.push(obj)
                            }       
                        })
                        this.setState({
                            data:[],
                            select_data: temp_arr,
                            select_data_loader: false, 
                            teamName: localStorage.getItem('teamName')
                        }, () => {
                            if(this.selected_team_ref.current){
                                this.selected_team_ref.current.value = "null"
                            }
                        })
                        
                    })
                }
            }
        }

        if(prev.match.params.teamId !== this.props.match.params.teamId) {
            if(prev.match.params.teamId !== undefined) {
                const detailed_button_data = this.state.detailed_button_data.map((button, pos) => {
                    return {
                        ...button,
                        link: `/organisation/${this.props.match.params.id}/user/collaboration/detailed/${pos + 1}/${this.props.match.params.teamId}`
                    }
                })
                this.setState({
                    selected_team: this.props.match.params.teamId,
                    detailed_button_data
                })
            }
        }


        if(prevState.selected_team !== this.state.selected_team) {
            const team_id = this.state.selected_team

            if(this.props.getCollaborationDataData && this.state.canCallApiIfNoData) {
                let selected_team = ''
                this.state.select_data.map((val, key) => {
                    if(val.id == team_id) {
                        selected_team = val.team_name
                    }
                })
                this.setState({
                    data: dataFormater(this.props, this.props.getCollaborationDataData.data,"collaboration_all", {
                        selected_team: selected_team,
                        currentTeam: localStorage.getItem('teamName'),
                        currentTeamId: team_id
                    }),
                    data_percentage_chart: dataFormater(this.props,this.props.getCollaborationDataData.data,"collab_percentage_data", {
                        selected_team: selected_team,
                        currentTeam: localStorage.getItem('teamName'),
                        currentTeamId: team_id
                    }),
                    canCallApiIfNoData: false
                })
            }else {
                if(team_id !== "null" || team_id !== null) {
                    this.setState({
                        collabLoader: true
                    }, () => {
                        this.props.dispatch(collaborationAction.collaborationDataAction({"team_id": parseInt(team_id,10),"current_team_assessment_id": this.props.saveAssesorGroupListResponse.team_members.filter(val => val.filtered !== undefined ? val.filtered : true).map(val => val.assessment.id),"relation_group_ids":this.props.saveAssesorIdsResponse.assessorIds}, (callbackData) => {
                            if(callbackData.response) {
                                if(callbackData.response.status !== 200) {
                                    this.setState({
                                        collabLoader: false,
                                    }, () => {
                                        if(callbackData.response.status === 500) {
                                            this.setState({
                                                collabErrorMessage: 'Some Error Occured'
                                            })
                                        }else {
                                            this.setState({
                                                collabErrorMessage: callbackData.response.data.message
                                            })
                                        }
                                    })
                                }
                            }else {
                                let selected_team = ''
                                
                                this.state.select_data.map((val, key) => {
                                    if(val.id == team_id) {
                                        selected_team = val.team_name
                                    }
                                })
                                this.setState({
                                    data: dataFormater(this.props, callbackData.data,"collaboration_all", {
                                        selected_team: selected_team,
                                        currentTeam: localStorage.getItem('teamName'),
                                        currentTeamId: team_id
                                    }),
                                    data_percentage_chart: dataFormater(this.props,callbackData.data,"collab_percentage_data", {
                                        selected_team: selected_team,
                                        currentTeam: localStorage.getItem('teamName'),
                                        currentTeamId: team_id
                                    }),
                                    collabLoader: false,
                                    collabErrorMessage: ''
                                })
                            }
                        }))
                    })
                }else {
                    this.props.history.push(`/organisation/${this.props.match.params.id}/user/collaboration`)
                }
            }

        }

        if(prev.getPaAnanlyzeTeamListResponse != this.props.getPaAnanlyzeTeamListResponse) {
            if(this.props.getPaAnanlyzeTeamListResponse != '') {
                this.setState({selected_team: null})
                var temp_arr = []
                var reformatdata = []
                    var tableData = this.props.getPaAnanlyzeTeamListResponse.data
                    for (var key in tableData) {
                        if (tableData.hasOwnProperty(key)) {
                            reformatdata = reformatdata.concat(tableData[key])
                        }
                    }

                var sortedArray =  reformatdata.sort(function(a, b) { 
                    return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
                    });

                sortedArray.map(obj => {
                        if(localStorage.getItem('teamId') != obj.id) {
                            temp_arr.push(obj)
                        }
                        this.setState({data:[],select_data: temp_arr, select_data_loader: false, teamName: localStorage.getItem('teamName')},() => {
                        })
                        
                    })
            }
        }

        if(prev.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse}, () => {
                    if(this.props.match.params.teamId && this.state.selected_team === null && this.props.saveAssesorIdsResponse !== '') {
                        this.setState({
                            selected_team: this.props.match.params.teamId
                        },() => {
                        })
                    }
                })
            }
        }

        if(prev.saveAssesorIdsResponse !== this.props.saveAssesorIdsResponse) {
            if(this.props.saveAssesorIdsResponse !== '') {
                if(this.props.match.params.teamId && this.state.selected_team === null && this.props.saveAssesorGroupListResponse !== '') {
                    this.setState({
                        selected_team: this.props.match.params.teamId
                    })
                }else if(this.state.selected_team !== null) {
                    const team_id = this.state.selected_team
                    this.setState({
                        collabLoader: true
                    }, () => {
                        this.props.dispatch(collaborationAction.collaborationDataAction({"team_id": parseInt(team_id,10),"current_team_assessment_id": this.props.saveAssesorGroupListResponse.team_members.filter(val => val.filtered !== undefined ? val.filtered : true).map(val => val.assessment.id),"relation_group_ids":this.props.saveAssesorIdsResponse.assessorIds}, (callbackData) => {
                            if(callbackData.response) {
                                if(callbackData.response.status !== 200) {
                                    this.setState({
                                        collabLoader: false,
                                    }, () => {
                                        if(callbackData.response.status === 500) {
                                            this.setState({
                                                collabErrorMessage: 'Some Error Occured'
                                            })
                                        }else {
                                            this.setState({
                                                collabErrorMessage: callbackData.response.data.message
                                            })
                                        }
                                    })
                                }
                            }else {
                                let selected_team = ''
                                
                                this.state.select_data.map((val, key) => {
                                    if(val.id == team_id) {
                                        selected_team = val.team_name
                                    }
                                })
                                this.setState({
                                    data: dataFormater(this.props, callbackData.data,"collaboration_all", {
                                        selected_team: selected_team,
                                        currentTeam: localStorage.getItem('teamName'),
                                        currentTeamId: team_id
                                    }),
                                    data_percentage_chart: dataFormater(this.props,callbackData.data,"collab_percentage_data", {
                                        selected_team: selected_team,
                                        currentTeam: localStorage.getItem('teamName'),
                                        currentTeamId: team_id
                                    }),
                                    collabLoader: false,
                                    collabErrorMessage: ''
                                })
                            }
                        }))
                    })
                }
            }
        }


        if(prev.match.params.colabo !== this.props.match.params.colabo) {
            if(this.props.match.params.teamId) {
                this.setState({
                    selected_team: this.props.match.params.teamId
                })
            }
        }


        if(prev.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {


        if(this.props.saveAssesorIdsResponse !== '' && this.props.saveAssesorGroupListResponse !== '') {
            if(this.props.match.params.teamId && this.state.selected_team === null) {
                this.setState({
                    selected_team: this.props.match.params.teamId
                })
            }
        }

        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '' ) {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Collaboration') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse})
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
        //
        if(this.props.getPaAnanlyzeTeamListResponse != '') {
            this.setState({selected_team: null}, () => {
                if(this.props.saveAssesorIdsResponse !== '' && this.props.saveAssesorGroupListResponse !== '') {
                    if(this.props.match.params.teamId) {
                        this.setState({
                            selected_team: this.props.match.params.teamId,
                            canCallApiIfNoData: true
                        })
                    }
                }
            })
            var temp_arr = []
            var reformatdata = []
                var tableData = this.props.getPaAnanlyzeTeamListResponse.data
                for (var key in tableData) {
                    if (tableData.hasOwnProperty(key)) {
                        reformatdata = reformatdata.concat(tableData[key])
                    }
                }

            var sortedArray =  reformatdata.sort(function(a, b) { 
                return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
                });

            sortedArray.map(obj => {
                    if(localStorage.getItem('teamId') != obj.id) {
                        temp_arr.push(obj)
                    }
                    this.setState({data: [],select_data: temp_arr, select_data_loader: false, teamName: localStorage.getItem('teamName')},() => {
                    })
                    
                })
        }
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    controlSelects = (e) => {
        const team_id = e.target.value

        if(this.props.match.params.colabo) {
            this.props.history.push(`/organisation/${this.props.match.params.id}/user/collaboration/detailed/${this.props.match.params.colabo}/${team_id}`)
        }else{
            this.setState({
                selected_team: team_id === 'null' ? null : team_id
            })
        }
    }

    stateHandler(key) {
        this.setState({ view_detailed_comparison: key })
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    render() {
        const { navData, select_data } = this.state;
        const { saveAssesorGroupListResponse } = this.props;


        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                            this.props.singleValidatorResponse ?
                            <p className="text-center m-3">
                                 Team Members should be more than 2
                            </p>:
                            <div className="swot-container-sub">
                                {
                                    typeof this.props.saveAssesorIdsResponse !== 'string' ?
                                        this.props.saveAssesorIdsResponse.assessmentIds.length && this.props.saveAssesorIdsResponse.assessorIds.length ?
                                            <div className="d-flex justify-content-center drop-down-container my-2">
                                                <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Compare Team {this.state.teamName} with</h6>
                                                <select
                                                    key={select_data}
                                                    className="drop-down"
                                                    onChange={(e) => this.controlSelects(e)}
                                                    value={this.state.selected_team}
                                                    ref={this.selected_team_ref}
                                                >
                                                    {
                                                        select_data.map((val, key) => {
                                                            return (
                                                                    <React.Fragment>
                                                                        {
                                                                            key === 0 ?
                                                                                <option selected="selected" value="null" disabled>Choose Team</option>
                                                                            :
                                                                                null
                                                                        }
                                                                        <option key={key} value={val.id} >{val.team_name}</option>
                                                                    </React.Fragment>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        :
                                            <div className="d-flex justify-content-center drop-down-container m-3">
                                                <p>{this.props.saveAssesorIdsResponse.assessmentIds.length === 0 ? 'No Team Members Available!' : 'No Relations Available!'}</p>
                                            </div>
                                    :
                                        null
                                            

                                }
                                {
                                    !this.state.collabLoader && this.state.collabErrorMessage.length ?
                                        <p className="text-center mt-4">
                                            {this.state.collabErrorMessage}
                                        </p>
                                    :
                                    this.state.view_detailed_comparison == null ?
                                        <div>
                                            {
                                                this.props.match.params.colabo == undefined ?
                                                    <div className="gradient-flex" style={{ paddingLeft: 75, paddingRight: 75, paddingTop: 30 }}>
                                                        {
                                                            this.state.selected_team !== null ?
                                                                <React.Fragment>
                                                                    
                                                                    <div className="py-1 px-3">
                                                                        <h6 className="font-weight-bold font-italic text-center">Each team has its unique strengths and you can help the teams learn from each other. Have the team leads/managers from one team share their knowledge/practices with the other team.</h6>
                                                                    </div>
                                                                    {
                                                                        this.state.collabLoader ?
                                                                            <i className="fa fa-spinner fa-spin"></i>
                                                                        :
                                                                            <DynamicGradientTables key={this.state.data} classNameProps={this.state.class_name} data={this.state.data.map(gradientData => ({...gradientData, noChildContent: true}))} />
                                                                    }
                                                                </React.Fragment>
                                                            :
                                                                typeof this.props.saveAssesorIdsResponse !== 'string' ?
                                                                    this.props.saveAssesorIdsResponse.assessmentIds.length && this.props.saveAssesorIdsResponse.assessorIds.length ?
                                                                        <h6 className="font-weight-bold text-center">Select a team</h6>
                                                                    :
                                                                        null
                                                                :
                                                                    null
                                                        }
                                                    </div>
                                                    :
                                                    <div key={this.props.match.params.colabo} className="gradient-flex" style={{ paddingLeft: 45, paddingRight: 45, paddingTop: 30 }}>
                                                        {   
                                                            this.state.collabLoader ?
                                                                <i className="fa fa-spinner fa-spin"></i>
                                                            :
                                                                this.state.data.map((obj, key) => {
                                                                    var temp = {}
                                                                    if (obj.id == this.props.match.params.colabo) {
                                                                        temp = obj
                                                                        var filtered_content= []
                                                                        temp.child_content.map((ob, i) => {
                                                                            if(ob.child_header.length > 20) {
                                                                                temp.header_sub_text = ob.child_header
                                                                            }
                                                                            if(!ob.sub_header_enable) {
                                                                                if(ob.child_header != '') {
                                                                                    filtered_content.push(ob)
                                                                                }
                                                                            }
                                                                        })
                                                                        temp.child_content = filtered_content
                                                                        temp.child_content = temp.child_content.map(obj => {
                                                                            obj.link = ''
                                                                            return obj
                                                                        })
                                                                        var colaboArray = [temp]
                                                                        return (
                                                                            <DynamicGradientTables key={key} classNameProps={this.state.detailed_class_name} data={colaboArray} isMarginEnabled={true} />
                                                                        )
                                                                    }
                                                                })
                                                        }
                                                        {
                                                            this.state.collabLoader ?
                                                                null
                                                            :
                                                                <div className="d-flex flex-row pl-3 pr-2 justify-content-between">
                                                                    <CircularButtonGroup buttonGroupData={this.state.main_button_data} swotCatagory={"Collaboration"} textAlign={'justify-content-start'} singleButton={true} />
                                                                    <div className="text-center d-flex align-items-center">
                                                                        <button type="button" className="text-white py-1 px-3 font-italic cursor-pointer" style={{background: '#666666', fontSize: 12}} onClick={() => this.setState({ view_detailed_comparison: "ACHIEVEMENT" })}>
                                                                                View Attribute wise Comparison
                                                                        </button>
                                                                    </div>
                                                                    <CircularButtonGroup show_button_group_container_class="no_class" buttonGroupData={this.state.detailed_button_data} swotCatagory={this.props.match.params.colabo} textAlign={'justify-content-end'} singleButton={false} />
                                                                </div>
                                                        }
                                                    </div>
                                            }
                                        </div>
                                        :
                                            this.state.selected_team === null ?
                                                null 
                                            :
                                                this.state.collabLoader ?
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                :
                                                    <div key={this.state.view_detailed_comparison} className="gradient-flex" style={{ paddingTop: 10 }}>
                                                        <div className="">
                                                            <h5 className="font-weight-bold text-center">{this.state.view_detailed_comparison}</h5>
                                                        </div>
                                                        <PercentageChart orientationName={this.state.view_detailed_comparison} data={this.state.data_percentage_chart} teamId={this.state.teamId} teamName={this.state.teamName} />
                                                        <CircularButtonGroup buttonGroupData={this.state.button_data} swotCatagory={this.state.view_detailed_comparison} singleButton={false} onClick={this.stateHandler.bind(this)} />
                                                    </div>
                                }
                                {
                                    this.props.match.params.colabo == undefined ?
                                        <div>
                                            
                                            {
                                                this.state.view_detailed_comparison === null && this.state.selected_team === null ?
                                                    null :
                                                    !this.state.collabLoader && !this.state.collabErrorMessage.length && !this.state.view_detailed_comparison ?
                                                        <div className="gradient-flex text-center" style={{ paddingLeft: 75, paddingRight: 75, paddingTop: 20, paddingBottom: 20 }}>
                                                            <button type="button" className="bg-dark text-white py-1 px-3" onClick={() => this.setState({ view_detailed_comparison: "ACHIEVEMENT" })}>
                                                                View Detailed Comparison
                                                            </button>
                                                        </div>
                                                    :
                                                        null
                                            }
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        }
                    </div>
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;

         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

         const singleValidatorResponse = state.singleValidatorReducer.data;


         //Pa analytics Team list
         const { paAnaTeamListLoading } = state.getPaAnanlyzeTeamListReducer
         const { paAnaTeamListError} = state.getPaAnanlyzeTeamListReducer.error
         const getPaAnanlyzeTeamListResponse = (!paAnaTeamListLoading && !paAnaTeamListError) ?  state.getPaAnanlyzeTeamListReducer.data : '';


    //collab main data
    const { getCollaborationDataLoading } = state.collaborationMainDataReducer;
    const getCollaborationDataError = state.collaborationMainDataReducer.error;
    const getCollaborationDataData = (!getCollaborationDataLoading && !getCollaborationDataError) ? state.collaborationMainDataReducer.data : null

    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,
        getPaAnanlyzeTeamListResponse,
        paAnaTeamListError,
        paAnaTeamListLoading,

        singleValidatorResponse,


        //collab main data
        getCollaborationDataLoading,
        getCollaborationDataError,
        getCollaborationDataData

    }
}

export default connect(mapStateToProps)(Collaboration)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/Collaboration/index.js